
import { supabase } from "@/integrations/supabase/client";

export const fetchStudentByAuthId = async (authId: string) => {
  console.log('=== FETCHING STUDENT BY AUTH ID ===');
  console.log('Auth ID:', authId);
  
  const { data, error } = await supabase
    .from('students')
    .select('*')
    .eq('auth_id', authId)
    .single();
    
  if (error) {
    console.error('Error fetching student:', error);
    return null;
  }
  
  console.log('Found student:', data);
  return data;
};

export const fetchTrainerSettings = async (trainerId: string) => {
  console.log('=== FETCHING TRAINER SETTINGS ===');
  console.log('Trainer ID:', trainerId);
  
  const { data, error } = await supabase
    .from('schedule_settings')
    .select('*')
    .eq('trainer_id', trainerId)
    .single();
    
  if (error) {
    console.error('Error fetching trainer settings:', error);
    return null;
  }
  
  console.log('Found trainer settings:', data);
  return data;
};

export const fetchScheduledEvents = async (trainerId: string) => {
  console.log('=== FETCHING SCHEDULED EVENTS ===');
  console.log('Trainer ID:', trainerId);
  
  const { data, error } = await supabase
    .from('schedule_events')
    .select('*')
    .eq('trainer_id', trainerId)
    .gte('start_time', new Date().toISOString());
    
  if (error) {
    console.error('Error fetching scheduled events:', error);
    return null;
  }
  
  console.log('Found scheduled events:', data?.length || 0, 'events');
  console.log('Scheduled events details:', data);
  return data;
};

export const fetchScheduleRequests = async (trainerId: string) => {
  console.log('=== FETCHING SCHEDULE REQUESTS ===');
  console.log('Trainer ID:', trainerId);
  
  const { data, error } = await supabase
    .from('schedule_requests')
    .select('*')
    .eq('trainer_id', trainerId)
    .gte('requested_date', new Date().toISOString());
    
  if (error) {
    console.error('Error fetching schedule requests:', error);
    return null;
  }
  
  console.log('Found schedule requests:', data?.length || 0, 'requests');
  console.log('Schedule requests details:', data);
  return data;
};

export const setupRealtimeChannel = (onUpdate: () => void) => {
  console.log('=== SETTING UP REALTIME CHANNEL ===');
  
  const channel = supabase
    .channel('schedule-updates')
    .on('postgres_changes', {
      event: '*',
      schema: 'public',
      table: 'schedule_events'
    }, (payload) => {
      console.log('Realtime: schedule_events change:', payload);
      onUpdate();
    })
    .on('postgres_changes', {
      event: '*',
      schema: 'public',
      table: 'schedule_requests'
    }, (payload) => {
      console.log('Realtime: schedule_requests change:', payload);
      onUpdate();
    })
    .subscribe();
    
  console.log('Realtime channel subscribed');
  return channel;
};
